module.exports = __webpack_public_path__ + "static/media/kiwi.713ef1d1.png";